export default import.meta.ROLLUP_FILE_URL_tDlnVrxS4eruJCE2lYpUfw